<template>
  <div class="Plays">
    <div class="Plays__close" @click="setPlays(false)"></div>
    <div class="Plays__title">
      What do you want to watch?
    </div>
    <div class="row">
      <div class="Plays__item col-12 col-md-6 mb-3" v-for="item in playlist.plays" @click="$emit('playVideo', item.url)">
        <div class="col-12 Plays__item__btn">{{ item.name }} ({{ item.duration }})</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    data() {
      return {
        sliderValue: 1,
      };
    },
    methods: {
      ...mapMutations(['setHighlights', 'setPlays', 'setPlayers', 'setPlaylist']),
    },
    computed: {
      ...mapState(['highlights', 'playlist', 'plays', 'players']),

    },
    components: {

    },
  };
</script>
<style lang="scss">
  .Plays {
    position: relative;
    background-color: rgba(0, 0, 0, .6);
    padding: 30px;
    border-radius: 10px;
    @media (min-width: 768px) {
      position: absolute;
      width: 80%;
      top: 80px;
      margin: 0 10%;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, .6);
    }
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &__close {
      cursor: pointer;
      position: absolute;
      top: 10px;
      left: 10px;
      background-image: url(../assets/img/ic_close.png);
      width: 20px;
      height: 20px;
      background-size: cover;
    }
    &__title{
      flex-basis: 100%;
      color: #00acff;
      text-align: center;
      margin-bottom: 20px;
    }
    &__item{
      &__btn{
        text-align: center;
        background-color: #00acff;
        padding: 5px 10px;
        color: white;
        border-radius: 100px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Plays.vue